import { defineStore } from "pinia";

export type HomePageTypes = 'chat' | 'client' | 'project'

export type HomePage = {
    page: HomePageTypes | null
}

export const homePageStore = defineStore({
    id: 'homePageStore',
    state: () => ({
        page: null
    } as HomePage),
    actions: {
        setCurrentPage (pageName: HomePageTypes) {
            if (['chat', 'client', 'project'].includes(pageName)) {
                this.page = pageName
            } else {
                this.page = 'chat'
            }
        }
    },
    getters: {
        currentPage(state) {
            return state.page;
        }
    }
})
